import PropTypes from 'prop-types';
import React from 'react';

import { isLocalURL } from '$utilities/browser';
import { slugify } from '../../utilities/slugify.js';
import Image from '$partials/media/image';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleContactBlock = ({
    items = null,
    isAccordionOrSection,
    isFirstInAccordion
}) => {
    return (
        <section className='relative'>
            <div className='layout-container'>
                <div className='layout-grid-negative-gutter flex'>
                    <div className='md:w-1/12' />

                    <div className='w-12/12 md:w-11/12 layout-grid-col-padding'>
                        <div className={`${isAccordionOrSection && !isFirstInAccordion ? 'border-t border-t-charcoal' : ''}`} />
                    </div>
                </div>
            </div>

            <div className='layout-container relative md:flex py-30 md:py-60'>
                <div className='md:w-1/12' />

                <div className='md:w-11/12 flex flex-col sm:gap-20 sm:flex-row'>
                    {items?.length > 0 && items?.map((item, idx) => {
                        return (
                            <div
                                className='sm:w-6/12 md:w-6/11'
                                key={idx}>
                                {item.title ? (
                                    <h2 className='type-style-4'>
                                        {item.title}
                                    </h2>
                                ) : (
                                    <div className='hidden sm:block type-style-4'>
                                        <span>&nbsp;</span>
                                    </div>
                                )}

                                <h3 className='type-style-1 mt-20 md:mt-20'>
                                    {item.heading}
                                </h3>

                                {item?.contactImage && (
                                    <div className='flow-root mt-20 md:mt-30'>
                                        <figure className='float-left w-80 h-80 mr-20'>
                                            <Image
                                                alt={item.contactImage.alt}
                                                {...item.contactImage} />
                                        </figure>

                                        <div className='mt-[38px]'>
                                            {item?.name && (
                                                <p className='type-style-3'>
                                                    {item.name}
                                                </p>
                                            )}

                                            {item?.role && (
                                                <p className='type-style-4'>
                                                    {item.role}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {item?.ctaUrl && (
                                    <a
                                        className={`pill-button mb-30 sm:mb-0 mt-30 md:mt-60 gtm-${slugify(item.ctaLabel)}`}
                                        href={item.ctaUrl}
                                        rel={isLocalURL(item.ctaUrl) ? null : 'noopener noreferrer'}
                                        target={isLocalURL(item.ctaUrl) ? null : '_blank'}>
                                        {item.ctaLabel}
                                    </a>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    items: PropTypes.array.isRequired,
    isAccordionOrSection: PropTypes.bool,
    isFirstInAccordion: PropTypes.bool,
};


ModuleContactBlock.propTypes = propTypes;

export default ModuleContactBlock;
